var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 66,
    viewBox: "0 0 65 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7696_323525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4793 16.9434C36.9641 16.9434 39.7891 14.0916 39.7891 10.5738C39.7891 7.05589 36.9641 4.2041 33.4793 4.2041C29.9944 4.2041 27.1694 7.05589 27.1694 10.5738C27.1694 14.0916 29.9944 16.9434 33.4793 16.9434Z",
    fill: "#2B99FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M19.4464 21.7251C22.2403 21.7251 24.5052 19.4388 24.5052 16.6184C24.5052 13.7981 22.2403 11.5117 19.4464 11.5117C16.6526 11.5117 14.3877 13.7981 14.3877 16.6184C14.3877 19.4388 16.6526 21.7251 19.4464 21.7251Z",
    fill: "#2B99FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M13.7883 35.4541C16.2217 35.4541 18.1943 33.4628 18.1943 31.0064C18.1943 28.5499 16.2217 26.5586 13.7883 26.5586C11.355 26.5586 9.38232 28.5499 9.38232 31.0064C9.38232 33.4628 11.355 35.4541 13.7883 35.4541Z",
    fill: "#2B99FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M19.8258 48.6277C21.7184 48.6277 23.2527 47.0789 23.2527 45.1684C23.2527 43.2578 21.7184 41.709 19.8258 41.709C17.9332 41.709 16.3989 43.2578 16.3989 45.1684C16.3989 47.0789 17.9332 48.6277 19.8258 48.6277Z",
    fill: "#2B99FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M33.9699 53.7961C35.5621 53.7961 36.8528 52.4932 36.8528 50.8859C36.8528 49.2786 35.5621 47.9756 33.9699 47.9756C32.3777 47.9756 31.0869 49.2786 31.0869 50.8859C31.0869 52.4932 32.3777 53.7961 33.9699 53.7961Z",
    fill: "#2B99FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M47.9486 46.8162C49.1202 46.8162 50.07 45.8575 50.07 44.6747C50.07 43.492 49.1202 42.5332 47.9486 42.5332C46.7769 42.5332 45.8271 43.492 45.8271 44.6747C45.8271 45.8575 46.7769 46.8162 47.9486 46.8162Z",
    fill: "#2B99FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M53.8771 32.3678C54.8385 32.3678 55.6178 31.5811 55.6178 30.6107C55.6178 29.6402 54.8385 28.8535 53.8771 28.8535C52.9158 28.8535 52.1365 29.6402 52.1365 30.6107C52.1365 31.5811 52.9158 32.3678 53.8771 32.3678Z",
    fill: "#2B99FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7696_323525",
    x: 1.38232,
    y: 0.204102,
    width: 62.2354,
    height: 65.5918,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7696_323525"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7696_323525",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingDots);
export default __webpack_public_path__ + "static/media/loading-dots.8c6665c1dd90f5688b65ad7e6a5fdf94.svg";
export { ForwardRef as ReactComponent };